export const version = "rlp/5.0.7";
//# sourceMappingURL=_version.js.map